import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

const categoryColors: Record<string, string> = {
  '恋爱': 'bg-accent-100 text-accent-800',
  '奇幻': 'bg-secondary-100 text-secondary-800',
  '动作': 'bg-primary-100 text-primary-700',
  '悬疑': 'bg-accent-200 text-accent-900',
  '恐怖': 'bg-secondary-200 text-secondary-900',
  '剧情': 'bg-primary-100 text-primary-800',
  '校园': 'bg-accent-100 text-accent-700',
  '热血': 'bg-secondary-100 text-secondary-700',
  '搞笑': 'bg-accent-100 text-accent-800',
  '冒险': 'bg-primary-100 text-primary-700',
};

export default function HotComics() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-10 md:mb-14">
          <div>
            <p className="text-sm text-foreground-400 font-label tracking-wider uppercase mb-2">
              Popular Comics
            </p>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 italic">
              热门推荐
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
            精选全网最受欢迎的韩国漫画，涵盖恋爱、奇幻、动作等多种类型，
            每一部都值得你细细品味
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-product-shop="">
          {featuredComics.slice(0, 6).map((comic, index) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative rounded-2xl overflow-hidden aspect-[3/4] mb-4">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩国漫画`}
                  title={`${comic.title} 韩漫在线阅读`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={index < 3 ? 'eager' : 'lazy'}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3">
                  <span className={`inline-block px-3 py-1 rounded-full text-xs font-label font-medium ${categoryColors[comic.categories[0]] || 'bg-secondary-100 text-secondary-800'}`}>
                    {comic.categories[0]}
                  </span>
                </div>
                {comic.status === '已完结' && (
                  <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-foreground-950/70 text-background-50 text-xs font-label">
                    已完结
                  </div>
                )}
              </div>
              <h3 className="text-base md:text-lg font-heading font-bold text-foreground-950 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-1">
                {comic.title}
              </h3>
              <div className="flex items-center gap-3 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-star-fill text-accent-500 text-xs"></i>
                  {comic.rating}
                </span>
                <span>{comic.author}</span>
                <span className="text-foreground-400">·</span>
                <span>{comic.chapters}话</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/categories"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-foreground-300 text-foreground-700 text-sm font-label font-medium cursor-pointer hover:bg-foreground-50 hover:border-foreground-400 transition-all whitespace-nowrap"
          >
            查看全部漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}